"use strict";'use strict';

var chunkUG752LRX_js = require('./chunk-UG752LRX.js');
require('./chunk-GKBSAB3C.js');



module.exports = chunkUG752LRX_js.ChevronLeft_default;
